const userStatus = {
    FAVORITE: 'favorite',
    ACCEPT: 'accept',
    INTEREST: 'interest',
    REJECT: 'reject',
};

export default userStatus;
